import React from 'react';
import {styled} from '@mui/material/styles';
import StepConnector, {stepConnectorClasses} from '@mui/material/StepConnector';
import {Box as MuiBox, ToggleButtonGroup, Tooltip, tooltipClasses} from '@mui/material';

const QontoStepIconRoot = styled('div')(({theme, ownerState}) => ({
    display: 'flex',
    height: 22,
    alignItems: 'center',

    '& .QontoStepIcon-circle': {
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '12px',
        fontWeight: 700,
        color: theme.palette.background.paper,

        backgroundColor: theme.palette.neutral[300],

        ...((ownerState.active || ownerState.completed) && {
            backgroundColor: theme.palette.primary.main,
        }),
    },
}));

export const QontoStepIcon = (props) => {
    const {active, completed, className, icon} = props;
    return (
        <QontoStepIconRoot ownerState={{active, completed}} className={className}>
            <div className="QontoStepIcon-circle">{icon}</div>
        </QontoStepIconRoot>
    );
};

export const QontoConnector = styled(StepConnector)(({theme}) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 11,
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)',
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.neutral[200],
        borderTopWidth: 1,
        borderRadius: 1,
    },
    [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
}));

export const CardBox = styled(MuiBox)(({theme}) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.lg,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    width: '100%',
    boxSizing: 'border-box',
}));

export const ContainerBox = styled(MuiBox)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: 0,
    margin: 0,
    width: '100%',
    boxSizing: 'border-box',
}));

export const CircleBox = styled(MuiBox, {
    shouldForwardProp: (prop) =>
        !['circleColor', 'size', 'borderColor'].includes(prop),
})(({theme, circleColor, size = 36, borderColor}) => ({
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,

    width: size,
    height: size,

    backgroundColor: circleColor || theme.palette.primary.main,
    border: borderColor ? `1px solid ${borderColor}` : 'none',
    color: 'inherit',
    lineHeight: 1,
}));

export const FlexBox = styled(MuiBox, {
    shouldForwardProp: (prop) =>
        !['direction', 'gap', 'justifyContent', 'alignItems'].includes(prop),
})(({theme, direction, gap, justifyContent, alignItems}) => ({
    display: 'flex',
    gap: gap || theme.spacing(1),
    flexDirection: direction || 'row',
    boxSizing: 'border-box',
    justifyContent: justifyContent || 'flex-start',
    alignItems: alignItems || 'flex-start',
    width: '100%',
    height: '100%'
}));

const StyledTooltip = styled(({className, bgcolor, textcolor, radius, fsize, ...props}) => (
    <Tooltip
        {...props}
        slotProps={{
            popper: {
                className: className,
            },
        }}
    />
), {
    shouldForwardProp: (prop) => !['bgcolor', 'textcolor', 'radius', 'fsize'].includes(prop),
})(({theme, bgcolor, textcolor, radius, fsize}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: bgcolor || '#424242',
        color: textcolor || theme.palette.background.paper,
        borderRadius: radius || '16px',
        fontSize: fsize || '14px',

        padding: '10.5px 14px',
        maxWidth: 520,
        fontWeight: 400,
        lineHeight: 1.5,
        boxSizing: 'border-box',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: bgcolor || '#424242',
        fontSize: '14px',
    },
}));

export const AppTooltip = ({
                               children,
                               title,
                               placement = "right",
                               arrow = true,
                               ...otherProps
                           }) => {
    return (
        <StyledTooltip
            title={title}
            placement={placement}
            arrow={arrow}
            {...otherProps}
        >
            {children}
        </StyledTooltip>
    );
};

export const UnitToggleContainer = styled(ToggleButtonGroup)(({theme}) => ({
    backgroundColor: theme?.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.xl,
    padding: theme.spacing(0.25),
    height: 32,
    '& .MuiToggleButtonGroup-grouped': {
        border: 0,
        borderRadius: theme.shape.xl,
        margin: 0,
        padding: theme.spacing(0, 1.5),
        textTransform: 'none',
        ...theme.typography.body2,
        color: 'rgba(0, 0, 0, 0.54)',
        transition: theme.transitions.create(['background-color', 'color'], {
            duration: 250,
        }),
        '&.Mui-selected': {
            backgroundColor: theme?.palette.primary.main, // Matches your AntSwitch green
            color: theme?.palette.background.paper,
        },
        '&.Mui-disabled': {
            border: 0,
        },
    },
}));
